import React from "react";
import styles from "./PricingList.module.css";
import "../../styles.css";
function PricingList() {
  return (
    <div className={styles.pricingListSection}>
      <div className={styles.pricingListContainer}>
        <span className="heading3 text-gray-500 ">Cjenik usluga</span>
        <div className={styles.pricingListGeneralServices}>
          <div className={styles.pricingListItems}>
            <div className={styles.pricingItemsTitle}>
              <span className="subheading1 text-mint uppercase-letters">
                Baby Spa
              </span>
              <span className="body-regular text-gray-400">
                uključuje hidroterapiju, masažu i razvojne vježbe
              </span>
            </div>
            <div className={styles.items}>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Baby Spa (50 min)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">50€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Baby Spa paket 4+1
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">200€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Baby Spa paket 6+2
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">300€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Baby Spa friends 1+1
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">90€</span>
              </div>
            </div>
          </div>
          <div className={styles.pricingListItems}>
            <div className={styles.pricingItemsTitle}>
              <span className="subheading1 text-mint uppercase-letters">
                Prenatalna masaža
              </span>
              <span className="body-regular text-gray-400">
                (masaža za trudnice)
              </span>
            </div>
            <div className={styles.items}>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Cijelo tijelo (45 min)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">40€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">Kinesiotape</span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">10€</span>
              </div>
            </div>
          </div>
        </div>
       <div className={styles.pricingListGeneralServices}>
            <div className={styles.pricingListItems}>
            <div className={styles.pricingItemsTitle}>
              <span className="subheading1 text-mint uppercase-letters">
                Trening za trudnice
              </span>
            </div>
            <div className={styles.items}>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Grupni trening (4 osobe u grupi)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">60€</span>
              </div>
                <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Individualan trening{" "}
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">40€</span>
              </div>
            </div>
          </div>
          <div className={styles.pricingListItems}>
            <div className={styles.pricingItemsTitle}>
              <span className="subheading1 text-mint uppercase-letters">
                Postpartum
              </span>
              <span className="body-regular text-gray-400">
                postpartum rehabilitacija
              </span>
            </div>
            <div className={styles.items}>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Individualan dolazak
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">40€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Postpartum paket (10x)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">350€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Postpartum masaža (45 min)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">40€</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pricingListGeneralServices}>
          <div className={styles.pricingListItems}>
            <div className={styles.pricingItemsTitle}>
              <span className="subheading1 text-mint uppercase-letters">
                Ostalo
              </span>
            </div>
            <div className={styles.items}>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Baby handling (40 min)
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">70€</span>
              </div>
               <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Razvojne vježbe
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">40€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Vježbe mame&bebe
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">65€</span>
              </div>
              <div className={styles.item}>
                <span className="body-regular text-gray-500">
                  Poklon bon Baby Spa
                </span>
                <span className={styles.divider} />
                <span className="body-regular text-gray-400">€</span>
              </div>
            </div>
          </div>
        </div>    
      </div>
    </div>
  );
}

export default PricingList;
